// tooltipDirective.js
import { ref, onUnmounted, watchEffect } from 'vue';

const createTooltip = (el, binding) => {
    const tooltip = document.createElement('div');
    tooltip.className = 'tooltip';
    tooltip.innerText = binding.value;
    document.body.appendChild(tooltip);

    const updatePosition = () => {
        const rect = el.getBoundingClientRect();
        tooltip.style.left = `${rect.left + rect.width / 2}px`;
        tooltip.style.top = `${rect.top}px`;
    };

    updatePosition();
    watchEffect(updatePosition);

    onUnmounted(() => {
        document.body.removeChild(tooltip);
    });
};

export default {
    mounted(el, binding) {
        const tooltipText = ref(binding.value);

        el.addEventListener('mouseenter', () => createTooltip(el, tooltipText));
        el.addEventListener('mouseleave', () => {
            const tooltip = document.querySelector('.tooltip');
            if (tooltip) document.body.removeChild(tooltip);
        });
    },
};
